export default {
  Arial: {
    name: "Arial",
    type: "sys",
    family: "Arial",
    weight: "400",
  },
  "Arial Bold": {
    name: "Arial Bold",
    type: "sys",
    family: "Arial",
    weight: "700",
  },
  Verdana: {
    name: "Verdana",
    type: "sys",
    family: "Verdana",
    weight: "400",
  },
  "Times New Roman": {
    name: "Times New Roman",
    type: "sys",
    family: "Times New Roman",
    weight: "400",
  },
  "Courier New": {
    name: "Courier New",
    type: "sys",
    family: "Courier New",
    weight: "400",
  },
  Georgia: {
    name: "Georgia",
    type: "sys",
    family: "Georgia",
    weight: "400",
  },
};

export const list = ["Arial", "Arial Bold", "Courier New", "Georgia", "Times New Roman", "Verdana"];
